export default {"src":"/_next/static/media/ball-orange.598cbcfd.svg","height":32,"width":25,"blurWidth":0,"blurHeight":0};